var portfolioPositionsTopFlop = {
	caption: {
		top: "Portfolio positions top results",
		flop: "Portfolio positions flop results",
		gainers: "Portfolio positions gainers",
		losers: "Portfolio positions losers"
	},
	name: "Naam",
	isin: "ISIN",
	lastPrice: "Laatste prijs",
	lastPriceDateTime: "Datum/Tijd",
	unrealizedPerformance: "Unrealized perf. in {currency}",
	unrealizedPerformanceRelative: "Winst/Verlies %",
	unrealizedPerformanceBar: "Winst/Verlies % of max",
	weight: "Belang %",
	marketValue: "Market value in {currency}",
	actions: "Acties",
	noPositions: "Geen resultaten gevonden"
};
var nl = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { nl as default, portfolioPositionsTopFlop };
